import * as React from 'react';
import { observer } from 'mobx-react';
import { JSSClassesProps } from 'react-jss';
import { ComponentJSSClasses } from './styles';
import { TagCheckbox } from '../TagCheckbox';
import { RatingGrade, ReviewRatingType } from '../../../../../models/hotel-reviews';
import S from '../../../../../stores';


export interface RatingFilterProps {}

interface StyledRatingFilterProps extends JSSClassesProps<ComponentJSSClasses>, RatingFilterProps {}

export const RatingFilter = observer((props: StyledRatingFilterProps) => {
    const { classes } = props;

    const isChecked = (rating: ReviewRatingType): boolean =>
        S.hotelReviews.ratingFilter.includes(rating);

    const handleChange = (rating: ReviewRatingType) => {
        S.hotelReviews.setRatingFilter(rating);
    };

    return (
        <div className={classes.container}>
            <TagCheckbox
                label={ReviewRatingType.Good}
                checked={isChecked(ReviewRatingType.Good)}
                onChange={() => handleChange(ReviewRatingType.Good)}
            >
                <span className={classes.inputName}>
                    <span className={classes.ratingTitle}>Положительная:</span>
                    <span>
                        {RatingGrade.Good}-{RatingGrade.Max}
                    </span>
                </span>
            </TagCheckbox>
            <TagCheckbox
                  label={ReviewRatingType.Bad}
                  checked={isChecked(ReviewRatingType.Bad)}
                  onChange={() => handleChange(ReviewRatingType.Bad)}
            >
                  <span className={classes.inputName}>
                      <span className={classes.ratingTitle}>С критикой:</span>
                      <span>
                          {RatingGrade.Min}-{RatingGrade.Good}
                      </span>
                  </span>
            </TagCheckbox>
        </div>
    );
});
